module.exports = __webpack_public_path__ + "static/media/why3.4b2a152c.png";